import { setLoader, unSetLoader, setErrorMessage } from "./appActions";
import { billing } from "store/requests";

export const addPayment = (payload) => {
  return async () => {
    try {
      let { data } = await billing({
        url: "/addPayment",
        addUserName: true,
        payload,
      });
      return data;
    } catch (error) {}
  };
};

export const updatePayment = (payload) => {
  return async () => {
    try {
      let { data } = await billing({
        url: "/updatePayment",
        addUserName: true,
        payload,
      });
      return data;
    } catch (error) {}
  };
};

export const deletePayment = (payload) => {
  return async () => {
    try {
      let { data } = await billing({
        url: "/deletePayment",
        addUserName: true,
        payload,
      });
      return data;
    } catch (error) {}
  };
};

export const getPayments = (payload) => {
  return async () => {
    try {
      let { data } = await billing({
        url: "/getPayments",
        addUserName: true,
        payload,
      });
      return data.map((x) => ({ ...x, id: x.charge_transaction_id }));
    } catch (error) {}
  };
};

export const validatePayment = (payload) => {
  return async () => {
    try {
      let { data } = await billing({
        url: "/paymentValidate",
        addUserName: true,
        payload,
      });
      return data;
    } catch (error) {}
  };
};

export const makePayment = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/makePayment",
        addUserName: true,
        payload,
      });
      return data;
    } catch (error) {
      const { data } = error.response;
      if (data && data.hasOwnProperty("Error"))
        dispatch(setErrorMessage(data.Error));
      else
        dispatch(
          setErrorMessage(error?.response?.data?.error || error.message),
        );
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const initiatePayment = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/initiatePayment",
        addUserName: true,
        payload,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const processPayment = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/processPayment",
        addUserName: true,
        payload,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const getBillingKeyInfo = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getBillingKeyInfo",
        addPracticeId: false,
        payload,
      });
      return data;
    } catch (error) {}
  };
};

export const getPaymentConfirmationDetails = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getPaymentConfirmationDetails",
      addPracticeId: false,
      payload,
    });
    return data;
  } catch (error) {}
};

export const getInvoiceDetails = (payload) => {
  return async () => {
    try {
      let { data } = await billing({
        url: "/getInvoiceDetails",
        payload,
        addPracticeId: false,
      });
      return data;
    } catch (error) {}
  };
};

export const getPatientCEBalances = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getPatientCEBalances",
      addUserName: true,
      payload,
    });
    return data.balances;
  } catch (error) {}
};

export const postPatientPayment = async (payload) => {
  try {
    let { data } = await billing({
      url: "/postPayment",
      addUserName: true,
      payload,
    });
    return data;
  } catch (error) {}
};
